<div class="content-inner background-section new-quota">

    <div class="title-bar background-transparent">

        <a class="back-button" (click)="cancelQuota(cancelmodal)"><img
                class="svg back-button mb-3" src="assets/ph-bhp-layout/svg/back.svg" /> {{
            translationKeys.SOPObservation.Back | translate}}</a>
        <div class="container-fluid background-transparent p-0">
            <div class="row">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-auto p-0">
                        <h2 class="page-title mb-4 space-container">{{ title | translate | labelSanitizer}}</h2>
                    </div>
                    <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                        <div class="row institution-name">
                            <img alt="Institution" class="mr-2" src="assets/img/menuActive/Institution.svg">

                        </div>

                    </div>
                </div>

                <div class="container-fluid alone evaluation-section p-0">
                    <form class="form-container" (ngSubmit)="saveQuota()" name="addQuotaInfo" [formGroup]="addQuotaInfo"
                        #ngForm="ngForm">
                        <div class="my-4">

                            <div class="row">
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">
                                        <!-- <ng-template> -->
                                        <div class="dropdown dropdown-bhp">
                                            <div class="dropdown-container-input" data-toggle="dropdown"
                                                aria-expanded="false" [ngClass]="{'disabled': status == 2}">
                                                <input type="text" formControlName="wardID" hidden />
                                                <input class="dropdown-toggle" type="text" formControlName="wardName"
                                                    readonly required
                                                    [ngClass]="{'is-invalid':addQuotaInfo.get('wardName').errors && (addQuotaInfo.get('wardName').touched || addQuotaInfo.get('wardName').dirty || ngForm.submitted)}">
                                                <span class="label-dropdown">{{ translationKeys.Configure.Ward |
                                                    translate }}<span class="mandatory">*</span></span>
                                                <img class="dropdown-arrow"
                                                    src="assets/icons/arrowDropdownOutlined.svg" />
                                            </div>
                                            <ul class="dropdown-menu">
                                                <li [ngValue]="ward" class="dropdown-item" *ngFor="let ward of wardList"
                                                    (click)="getDepartment(ward)"
                                                    [ngClass]=" addQuotaInfo.get('wardName').value === ward.wardName ? 'active' : ''">
                                                    {{ward.wardName | translate | labelSanitizer}}</li>
                                            </ul>
                                        </div>
                                        <div class="invalid-feedback"
                                            *ngIf="addQuotaInfo.get('wardName').errors && (addQuotaInfo.get('wardName').touched ||addQuotaInfo.get('wardName').dirty || ngForm.submitted)">
                                            <span *ngIf="addQuotaInfo.get('wardName').errors.required">
                                                {{translationKeys.ErrorMessages.RequiredWard | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">
                                        <label>{{ translationKeys.Configure.Department | translate }}</label>
                                        <p>{{ addQuotaInfo.get('departmentName').value.departmentName | translate}} ({{
                                            addQuotaInfo.get('departmentTypeName').value | translate }})</p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">

                                        <mat-form-field class="example-full-width">
                                            <mat-label>{{ 'CONFIGURE.NUMBER_OF_QUOTA' | translate }}</mat-label>

                                            <input matInput inputSanitizer type="text" min="0" class="form-control"
                                                name="numberofQuota" formControlName="numberofQuota"
                                                [ngClass]="{'is-invalid':addQuotaInfo.get('numberofQuota').errors && (addQuotaInfo.get('numberofQuota').touched || addQuotaInfo.get('numberofQuota').dirty || ngForm.submitted)}"
                                                onkeydown="return /[0-9]/i.test(event.key) || event.key == 'Backspace' || event.key == 'Delete' || event.key == 'ArrowLeft' || event.key == 'ArrowRight'"
                                                placeholder="{{'CONFIGURE.ENTER.NUMBER_OF_QUOTA' | translate}}"
                                                required>
                                        </mat-form-field>

                                        <div class="invalid-feedback"
                                            *ngIf="addQuotaInfo.get('numberofQuota').errors && (addQuotaInfo.get('numberofQuota').touched ||addQuotaInfo.get('numberofQuota').dirty  || ngForm.submitted)">
                                            <span *ngIf="addQuotaInfo.get('numberofQuota').errors.required">
                                                {{'GENERAL.QUOTA' | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-control form-control-width">
                                        <div class="row mr-0 IEContain">
                                            <div class="col-md-6 col-sm-12 pr-0">
                                                <div class="form-group">
                                                    <label for="startDate">{{ 'CONFIGURE.START_DATE' | translate
                                                        }}</label><span class="mandatory">*</span>

                                                    <ng-template [ngIf]="status != 2">
                                                        <mat-form-field appearance="fill" class="date-form-field"
                                                            [ngClass]="{'is-invalid':addQuotaInfo.get('startDate').errors && (addQuotaInfo.get('startDate').touched || addQuotaInfo.get('startDate').dirty || ngForm.submitted)}">
                                                            <input (click)="startDatepicker.open()" matInput
                                                                [matDatepicker]="startDatepicker"
                                                                placeholder="{{'CONFIGURE.ENTER.START_DATE' | translate}}"
                                                                formControlName="startDate" readonly required
                                                                (ngModelChange)="selectStartDate()">
                                                            <mat-datepicker-toggle matSuffix
                                                                [for]="startDatepicker"></mat-datepicker-toggle>
                                                            <mat-datepicker #startDatepicker></mat-datepicker>
                                                        </mat-form-field>

                                                        <div class="invalid-feedback"
                                                            *ngIf="addQuotaInfo.get('startDate').errors && (addQuotaInfo.get('startDate').touched ||addQuotaInfo.get('startDate').dirty  || ngForm.submitted)">
                                                            <span *ngIf="addQuotaInfo.get('startDate').errors.required">
                                                                {{'ERROR_MESSAGES.REQUIRED.START_DATE' | translate }}
                                                            </span>
                                                        </div>
                                                    </ng-template>

                                                    <ng-template [ngIf]="status == 2">
                                                        <div class="pt-2">
                                                            {{addQuotaInfo.get('startDate').value | date}}
                                                        </div>
                                                    </ng-template>

                                                </div>
                                            </div>
                                            <div class="col-md-6 col-sm-12 pr-0">
                                                <div class="form-group">
                                                    <label for="endDate">{{ 'CONFIGURE.END_DATE' | translate
                                                        }}</label><span class="mandatory">*</span>

                                                    <mat-form-field appearance="fill" class="date-form-field"
                                                        [ngClass]="{'is-invalid':addQuotaInfo.get('endDate').errors && (addQuotaInfo.get('endDate').touched || addQuotaInfo.get('endDate').dirty || ngForm.submitted)}">
                                                        <input (click)="endDatepicker.open()" matInput
                                                            [matDatepicker]="endDatepicker"
                                                            placeholder="{{'CONFIGURE.ENTER.END_DATE' | translate}}"
                                                            formControlName="endDate" readonly required
                                                            (ngModelChange)="selectEndDate()" [min]="minEndDate">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="endDatepicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #endDatepicker></mat-datepicker>
                                                    </mat-form-field>
                                                    <div class="invalid-feedback"
                                                        *ngIf="addQuotaInfo.get('endDate').errors && (addQuotaInfo.get('endDate').touched ||addQuotaInfo.get('endDate').dirty  || ngForm.submitted)">
                                                        <span *ngIf="addQuotaInfo.get('endDate').errors.required">
                                                            {{'ERROR_MESSAGES.REQUIRED.END_DATE' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">
                                        <div class="form-group top-input">
                                            <mat-form-field class="example-full-width">
                                                <mat-label>{{ 'CONFIGURE.NUMBER_OF_DAYS' | translate }}</mat-label>
                                                <input matInput inputSanitizer type="text"
                                                    formControlName="numberofDays" maxlength="40" name="numberofDays"
                                                    placeholder="{{'CONFIGURE.ENTER_NUMBER_OF_DAYS' | translate}}"
                                                    readonly>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end buttons-section">
                                <button type="button" class="btn-cancel-bordered-bd separate-buttons"
                                    (click)="cancelQuota(cancelmodal)">{{ translationKeys.Authorization.Cancel |
                                    translate }}</button>
                                <button type="submit" class="btn btn-continue-bordered-bd">{{
                                    translationKeys.Authorization.Save | translate }}</button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>

            <!-- Modal - Add User Confirmation -->
            <ng-template #cancelmodal>
                <div class="mb-4 modal-header justify-content-between align-items-center">
                    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
                    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img
                            src="assets/ph-bhp-layout/svg/remove.svg"> </a>
                </div>
                <div class="modal-body">
                    <p> {{ 'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate }} </p>
                </div>
                <div class="modal-footer">
                    <div class="align-items-end d-flex">
                        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{
                            'LAYOUT_MODULE.STAY' | translate }}</button>
                        <button (click)="backManageQuota();modalRef.hide()" class="btn-bd-empty">{{
                            'LAYOUT_MODULE.LEAVE' | translate}}</button>
                    </div>
                </div>
            </ng-template>


            <div class="side-appbar">
                <div class="container-fluid">
                </div>
            </div>

            <div id="page_overlay"></div>